// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"3JpVG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
"use client";
function Example() {
    let [value, setValue] = (0, _react.useState)(25);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
                label: "Cookies to buy",
                placeholder: "Enter a number",
                value: value,
                onChange: setValue
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Current value: ",
                    value
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":"kptFj","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4v9yW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Provider), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
        label: "Value",
        defaultValue: 1024,
        placeholder: "Enter a number"
    })
});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["NumberField","kptFj"],["Provider","31Rc2"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9X7T1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
"use client";
function Example(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Form), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.NumberField), {
                ...props,
                label: "Width",
                name: "width"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Button), {
                type: "submit",
                children: "Submit"
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Button","gZHck"],["Form","cHqN4"],["NumberField","kptFj"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _skeleton = require("./Skeleton");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf11';
    else rules += ' _Le11';
    if (props.isStaticColor) rules += ' Oe11';
    else rules += ' Oh11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' OlOVIhfcebS7sd11';
    rules += ' _Mc11';
    rules += ' _Kd11';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr11';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s11';
    rules += ' oR3ltQc11';
    rules += ' nR3ltQc11';
    rules += ' kR3ltQc11';
    rules += ' jR3ltQc11';
    if (props.isStandalone) {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.isStandalone) {
        rules += ' xc11';
        rules += ' _xa11';
    }
    if (props.isStandalone) {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.isStaticColor) rules += ' pl11';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po11';
        else if (props.isFocusVisible) rules += ' po11';
        else if (props.isHovered) rules += ' po11';
        else rules += ' pt11';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps11';
        else if (props.isFocusVisible) rules += ' ps11';
        else if (props.isHovered) rules += ' ps11';
        else rules += ' pu11';
    }
    rules += ' plOVIhfcA5Qiqd11';
    rules += ' plOVIhfcA5Qiqd11';
    rules += ' Yd11';
    rules += ' Xb11';
    rules += ' _2b11';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb11';
                rules += ' __Va11';
            } else if (props.isHovered) {
                rules += ' _Xb11';
                rules += ' __Va11';
            } else rules += ' _Xa11';
        }
    } else {
        rules += ' _Xb11';
        rules += ' __Va11';
    }
    rules += ' __ca11';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react-aria-components":"fOCdV","react":"a1TxN","./Skeleton":"1mUnF","@react-spectrum/utils":"jqfrX","@react-aria/utils":"2ViQu","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _icon = require("./Icon");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _utils1 = require("@react-spectrum/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "L") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "S") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else if (props.size === "XS") {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    } else {
        rules += ' uk11';
        rules += ' ucJ9TBTb11';
        rules += ' ud3Euai11';
        rules += ' uea11';
        rules += ' ugb11';
        rules += ' uhd11';
        rules += ' uje11';
        rules += ' u2NhKxcl11';
        rules += ' uic11';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b11';
        rules += ' vFHT6Dd11';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a11';
        rules += ' vFHT6Dd11';
    } else {
        rules += ' -_6BNtrc-c11';
        rules += ' vFHT6Dd11';
    }
    if (props.size === "XL") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "L") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "S") {
        rules += ' xb11';
        rules += ' _xa11';
    } else if (props.size === "XS") {
        rules += ' xb11';
        rules += ' _xa11';
    } else {
        rules += ' xb11';
        rules += ' _xa11';
    }
    if (props.size === "XL") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "L") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "S") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else if (props.size === "XS") {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    } else {
        rules += ' _Fd11';
        rules += ' _FnuYUweb11';
    }
    if (props.fillStyle === "outline") rules += ' pm11';
    else if (props.fillStyle === "subtle") rules += ' pm11';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg11';
        else if (props.variant === "chartreuse") rules += ' pg11';
        else if (props.variant === "yellow") rules += ' pg11';
        else if (props.variant === "orange") rules += ' pg11';
        else if (props.variant === "notice") rules += ' pg11';
        else rules += ' px11';
    }
    rules += ' sd11';
    rules += ' ea11';
    rules += ' egLWx3bb11';
    rules += ' _oa11';
    rules += ' Sv11';
    rules += ' SgLWx3bd11';
    rules += ' Rv11';
    rules += ' RgLWx3bd11';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc11';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG11';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c11';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc11';
    } else if (!minWidth) rules += ' N4dY0ec11';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec11';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn11';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b11';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd11';
    else rules += ' -SFnbic-_Jb11';
    rules += ' -Bu7z1c-oH5kTnc11';
    rules += ' oj11';
    rules += ' nj11';
    rules += ' kj11';
    rules += ' jj11';
    rules += ' qc11';
    rules += ' qsd11';
    rules += ' -Qg41Lb-IAxCW0c11';
    rules += ' -Qg41Lb-gLWx3bIYB8I11';
    rules += ' MAyFGYc11';
    rules += ' Td11';
    rules += ' Qd11';
    rules += ' -aRvJDd-Tu7Fubd11';
    rules += ' _Ca11';
    if (props.fillStyle === "outline") rules += ' g_g11';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f11';
        else if (props.variant === "cinnamon") rules += ' gP11';
        else if (props.variant === "brown") rules += ' gO11';
        else if (props.variant === "turquoise") rules += ' gy11';
        else if (props.variant === "pink") rules += ' gT11';
        else if (props.variant === "magenta") rules += ' gS11';
        else if (props.variant === "fuchsia") rules += ' gR11';
        else if (props.variant === "purple") rules += ' gM11';
        else if (props.variant === "indigo") rules += ' gK11';
        else if (props.variant === "blue") rules += ' gG11';
        else if (props.variant === "cyan") rules += ' gC11';
        else if (props.variant === "seafoam") rules += ' gz11';
        else if (props.variant === "green") rules += ' gA11';
        else if (props.variant === "celery") rules += ' gv11';
        else if (props.variant === "chartreuse") rules += ' gJ11';
        else if (props.variant === "yellow") rules += ' gW11';
        else if (props.variant === "orange") rules += ' gV11';
        else if (props.variant === "red") rules += ' gU11';
        else if (props.variant === "gray") rules += ' gI11';
        else if (props.variant === "negative") rules += ' gU11';
        else if (props.variant === "notice") rules += ' gV11';
        else if (props.variant === "positive") rules += ' gA11';
        else if (props.variant === "neutral") rules += ' gI11';
        else if (props.variant === "informative") rules += ' gG11';
        else if (props.variant === "accent") rules += ' gG11';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm11';
        else if (props.variant === "cinnamon") rules += ' gq11';
        else if (props.variant === "brown") rules += ' gn11';
        else if (props.variant === "turquoise") rules += ' g511';
        else if (props.variant === "pink") rules += ' gx11';
        else if (props.variant === "magenta") rules += ' gD11';
        else if (props.variant === "fuchsia") rules += ' gr11';
        else if (props.variant === "purple") rules += ' go11';
        else if (props.variant === "indigo") rules += ' gl11';
        else if (props.variant === "blue") rules += ' g211';
        else if (props.variant === "cyan") rules += ' gk11';
        else if (props.variant === "seafoam") rules += ' g411';
        else if (props.variant === "green") rules += ' g111';
        else if (props.variant === "celery") rules += ' g711';
        else if (props.variant === "chartreuse") rules += ' gp11';
        else if (props.variant === "yellow") rules += ' gN11';
        else if (props.variant === "orange") rules += ' gQ11';
        else if (props.variant === "red") rules += ' gB11';
        else if (props.variant === "gray") rules += ' g611';
        else if (props.variant === "negative") rules += ' gB11';
        else if (props.variant === "notice") rules += ' gQ11';
        else if (props.variant === "positive") rules += ' g111';
        else if (props.variant === "neutral") rules += ' g611';
        else if (props.variant === "informative") rules += ' g211';
        else if (props.variant === "accent") rules += ' g211';
    }
    rules += ' _jf11';
    rules += ' _kJ8iPYd11';
    rules += ' hXMFGYc11';
    rules += ' mc11';
    rules += ' lc11';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS11';
        else if (props.variant === "notice") rules += ' i9VrKkd11';
        else if (props.variant === "positive") rules += ' ip17Jm11';
        else if (props.variant === "neutral") rules += ' i0ruhAb11';
        else if (props.variant === "informative") rules += ' iG1ze4d11';
        else if (props.variant === "accent") rules += ' iG1ze4d11';
    } else rules += ' iA11';
    rules += ' -_8sjo0b-t5ZbAob11';
    if (props.size === "XL") rules += ' -M_-MBaYFfc11';
    else if (props.size === "L") rules += ' -M_-M3JjxG11';
    else if (props.size === "S") rules += ' -M_-MCe2o8c11';
    else if (props.size === "XS") rules += ' -M_-MifsFYc11';
    else rules += ' -M_-M4dY0ec11';
    rules += ' -_k_-_kc11';
    rules += ' -h_-hc11';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _utils1.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG11';
                        rules += ' QAzEcG11';
                        rules += ' _Jb11';
                        rules += ' _Nc11';
                        rules += ' Pc11';
                        rules += ' _Yb11';
                        if (props.overflowMode === "wrap") rules += ' _7b11';
                        else if (props.overflowMode === "truncate") rules += ' _7c11';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _reactAriaComponents.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja11"
                    }),
                    styles: " ZuUmpre11 FuUmpre11 I67logd11 _va11"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _utils.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components":[["Provider","bA6Cz"],["TextContext","jt9fm"]],"@react-aria/utils":"3upVm","./Icon":"jQAJE","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","@react-spectrum/utils":"jqfrX","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=NumberField.311e5232.js.map
